export default __webpack_public_path__ + "static/media/close-icon.3fde9381.svg";